var Timeline = function() {

	var comp = $('[data-component="timeline"]'), $item;

	this.init = function() {

		comp.find('.holder-arrow').on('click', function() {

			$item = $(this).closest('.timeline-item');

			$item.find('.see-message').slideUp();
			$item.find('.btn-arrow').removeClass('active');
			$item.find('.legend').text('Expandir');

			if (!$item.find('.see-message').is(':visible')) {
				$item.find('.legend').text('Retrair');

				$item.find('.btn-arrow').addClass('active');
				$item.find('.see-message').slideDown();
			}
		});

		$('.btn-message').on('click', function() {
			$('[data-component="modal"] .person .name').text($(this).closest('.content').find('.name').text());
		});

		$('[data-component="modal"] .close-modal').on('click', function() {
			$('[data-component="modal"] .person .name').text('');
		});
	}

	return this.init();

}
